import { render, staticRenderFns } from "./imgNews.vue?vue&type=template&id=81eb4c8a&scoped=true&"
import script from "./imgNews.vue?vue&type=script&lang=js&"
export * from "./imgNews.vue?vue&type=script&lang=js&"
import style0 from "./imgNews.vue?vue&type=style&index=0&id=81eb4c8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81eb4c8a",
  null
  
)

export default component.exports